<template>
  <div class="AgentSettingPage" v-if="agentInfo">
    <div class="content">
      <div class="headBox">
        <img class="headIcon" :src="agentInfo.icon" alt="" />
        <div class="agentTitle">{{ assistant_name }}</div>
        <div class="agentSummary" v-if="agentInfo.type != 'default'">
          {{ agentInfo.desction }}
        </div>
      </div>
      <div class="btnsBox">
        <div v-if="!phoneLogin" class="shareBtn" @click="clickShareBtn">
          分享智能体
        </div>
        <div class="clearBtn" @click="cleanConversationText">清除上下文</div>
        <div
          class="deleteBtn"
          v-show="agentInfo.type != 'default'"
          @click="clickDeleteBtn"
        >
          从对话列表删除
        </div>
      </div>
      <!--  举报    -->
      <div class="report" @click="showReportDialog = true">
        <img class="img" src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_report.png">
        <div class="text">举报</div>
      </div>
    </div>
    <!-- 确定清除上下文 -->
    <commonDialog2
      :show="showClearDialog"
      titleContent="确定清除上下文？"
      textContent="清除后，聊天记录将不可恢复。"
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="清除"
      rightBtnColor="#DC2626"
      @clickLeft="showClearDialog = false"
      @clickRight="confirmClear"
    ></commonDialog2>
    <!-- 确认删除 -->
    <commonDialog2
      :show="showDeleteDialog"
      titleContent="确定删除对话？"
      textContent="删除后，聊天记录将不可恢复"
      leftBtnText="取消"
      leftBtnColor="#007AFF"
      leftBtnBold
      rightBtnText="删除"
      rightBtnColor="#DC2626"
      @clickLeft="showDeleteDialog = false"
      @clickRight="confirmDelete"
    ></commonDialog2>

    <van-overlay
      class-name="shareShadeBox_overlay"
      :show="showShareShade"
      @click="showShareShade = false"
    >
      <img
        class="shareShadeBox"
        src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/shareShadeBox.png"
        alt=""
      />
    </van-overlay>
    <!--  举报的弹窗  -->
    <ReportDialog
        :ai_app_code="ai_app_code"
        v-model="showReportDialog">
    </ReportDialog>
  </div>
</template>

<script>
import * as Http from "@/api/HttpService.js";
import ReportDialog from "@/components/ReportDialog/ReportDialog.vue";
export default {
  components: {ReportDialog},
  data: function () {
    return {
      assistant_name: "",
      ai_app_code: "",
      conversation_id: "",
      showClearDialog: false,
      showDeleteDialog: false,
      showShareShade: false,
      // 智能体配置信息
      agentInfo: null,
      // 如果是短信登录，不允许分享
      phoneLogin: false,
      //举报弹窗的显示
      showReportDialog:false,
    };
  },
  mounted: async function () {
    let query = this.$route.query;
    this.assistant_name = query.assistant_name;
    this.ai_app_code = query.ai_app_code;
    this.conversation_id = query.conversation_id;
    this.phoneLogin = localStorage.getItem("phoneLogin_AI") ? true : false;
    this.getAgentInfo();
  },
  methods: {
    // 查询智能体信息
    getAgentInfo: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
        system: localStorage.getItem("channelCode_AI"),
      };
      await Http.getAgentInfo(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS")
            if (res.code == "SUCCESS") {
              this.agentInfo = res.originalData.data;
              let newChatInfo = this.$store.getters.newChatInfo;
              let defaultChatInfo = this.$store.getters.defaultChatInfo;
              let url = window.location.href;
              if (url.indexOf("?") != -1) {
                url = url + "&";
              } else {
                url = url + "?";
              }
              // 如果既有新对话，又有默认对话
              if (newChatInfo && defaultChatInfo) {
                // 如果当前的code是新对话   那么分享默认对话
                if (this.ai_app_code == newChatInfo.ai_app_code) {
                  url =
                    url +
                    `share_ai_app_code=${
                      defaultChatInfo.ai_app_code
                    }&desction=${
                      defaultChatInfo.desction
                    }&shareImgUrl=${encodeURIComponent(
                      defaultChatInfo.shareImgUrl
                    )}`;
                  window.history.replaceState(null, document.title, url);
                }
                // 否则  分享的是当前code的对话
                else {
                  url =
                    url +
                    `share_ai_app_code=${this.agentInfo.ai_app_code}&desction=${
                      this.agentInfo.desction
                    }&shareImgUrl=${encodeURIComponent(
                      this.agentInfo.shareImgUrl
                    )}`;
                  window.history.replaceState(null, document.title, url);
                }
              }
              // 只有新对话
              else if (newChatInfo) {
                // 什么都不用做
              }
              // 只有默认对话
              else if (defaultChatInfo) {
                // 分享当前code的对话
                url =
                  url +
                  `share_ai_app_code=${this.agentInfo.ai_app_code}&desction=${
                    this.agentInfo.desction
                  }&shareImgUrl=${encodeURIComponent(
                    this.agentInfo.shareImgUrl
                  )}`;
                window.history.replaceState(null, document.title, url);
              }
              // 既没有新对话 有没有默认对话
              else {
                // 什么都不用做
              }
            }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 清除上下文
    cleanConversationText: async function () {
      this.showClearDialog = true;
    },
    // 确认清除
    confirmClear: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
      };
      await Http.cleanConversationText(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.$toast("清除成功");
            this.$store.commit("hasClear", true);
            this.$store.commit("now_conversation_id", null);
            this.showClearDialog = false;
            setTimeout(() => {
              this.$router.go(-1);
            }, 100);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
    },

    // 点击删除按钮
    clickDeleteBtn: async function (value) {
      this.showDeleteDialog = true;
    },
    // 确认删除
    confirmDelete: async function () {
      let params = {
        ai_app_code: this.ai_app_code,
      };
      if (this.conversation_id) {
        params.conversation_id = this.conversation_id;
      }
      await Http.deleteMessage(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            this.$toast("删除成功");
            this.showDeleteDialog = false;
            this.$store.commit("hasClear", false);
            setTimeout(() => {
              this.$router.go(-2);
            }, 100);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击分享按钮
    clickShareBtn: function () {
      // 如果是微信小程序
      if (this.$store.getters.isWechatProgram) {
        console.log("这是微信小程序");
        this.showShareShade = true;
      } else {
        // app分享
        // channelCode 只有两种  要么dxlc  要么cxnt
        let shareConfig = [
          {
            name: "shareH5ToWechatSession",
            params: {
              shareableTitle: this.agentInfo.name,
              shareableDesc: this.agentInfo.desction,
              shareableThumbnail: this.agentInfo.icon,
              shareableUrl:
                process.env.VUE_APP_UMENG_FALL_H5 +
                `?ai_app_code=${
                  this.agentInfo.ai_app_code
                }&channelCode=${localStorage.getItem("channelCode_AI")}&env=${
                  process.env.VUE_APP_ENV
                }`,
            },
          },
          {
            name: "shareH5ToWechatTimeline",
            params: {
              shareableTitle: this.agentInfo.name,
              shareableDesc: this.agentInfo.desction,
              shareableThumbnail: this.agentInfo.icon,
              shareableUrl:
                process.env.VUE_APP_UMENG_FALL_H5 +
                `?ai_app_code=${
                  this.agentInfo.ai_app_code
                }&channelCode=${localStorage.getItem("channelCode_AI")}&env=${
                  process.env.VUE_APP_ENV
                }`,
            },
          },
        ];
        console.log(shareConfig);
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isAndroid) {
          DXLC_JSSDK(
            "onShareV2",
            {
              shareConfig: shareConfig,
            },
            (result) => {
              console.log(result);
              let res = JSON.parse(result);
              console.log(res);
            }
          );
        } else if (isIos) {
          DXLC_JSSDK(
            "onShareV2",
            {
              shareConfig: shareConfig,
            },
            (success) => {
              console.log(success);
            },
            (err) => {
              console.log(err);
            }
          );
        }
        // 否则是App
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./AgentSettingPage.scss";
</style>
